// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Utils
import {
    getDueDate,
    getDueReminder,
    getElementId,
    getShowDueDate,
} from '../../../../../../common/elements/utils/elementPropertyUtils';
import { getDueDateClass, getDueDatePillContent, getDueDatePopupId } from '../assignmentUiUtils';
import { getHybridUseCase } from '../../../../../hybridApp/hybridAppUtils';
import { HybridUseCase } from '../../../../../hybridApp/hybridAppConstants';

// Components
import TaskPill from '../TaskPill';
import TaskDueDatePopup from './TaskDueDatePopup';
import Icon from '../../../../../components/icons/Icon';

// Constants
import { REMINDER_VALUES } from './taskDueDateConstants';

// Styles
import './TaskDueDatePill.scss';

const TaskDueDatePill = (props) => {
    const { className, element, isEditable } = props;

    const elementId = getElementId(element);
    const popupId = getDueDatePopupId(elementId);

    const hasDueDate = getShowDueDate(element) && !!getDueDate(element);
    const dueReminder = getDueReminder(element);
    const hasReminder = dueReminder && dueReminder !== REMINDER_VALUES.NONE;

    return (
        <TaskPill
            className={classNames('TaskDueDatePill', className, getDueDateClass(element))}
            popupId={popupId}
            elementId={elementId}
            populated={hasDueDate}
            isEditable={isEditable && isEditableInHybridUseCase()}
            popup={<TaskDueDatePopup popupId={popupId} elementId={elementId} />}
        >
            {hasReminder && <Icon name="reminder-bell-mini" />}
            {getDueDatePillContent(element)}
        </TaskPill>
    );
};

const isEditableInHybridUseCase = () => {
    switch (getHybridUseCase()) {
        case HybridUseCase.ANDROID_BOARD_LIST:
        case HybridUseCase.IOS_BOARD_LIST:
            // At the time of commit, the date time picker is not
            // compatible with the board list.
            return false;
        case HybridUseCase.IOS_CANVAS:
        case HybridUseCase.IPAD_OS:
        default:
            return true;
    }
};

TaskDueDatePill.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    className: PropTypes.string,
    element: PropTypes.object.isRequired,
    isEditable: PropTypes.bool,
};

export default TaskDueDatePill;
